// User API utility functions

import apiServiceHandler from "./APIServiceHandler"
import { AddUserURL, DeleteUserURL, GetUsersURL, UpdateUserURL, ChangePasswordURL } from "./URLConstance"

export interface User {
  _id: string
  username: string
  emp_name: string
  password?: string
  isAdmin: boolean
  designation?: string
  teamLead?: string
  lunchOpted?: boolean;
  __v?: number
}

export interface UserFormData {
  username: string
  emp_name: string
  password: string
  isAdmin: boolean
  designation?: string
  teamLead?: string
  lunchOpted?: boolean;
}

export interface ChangePasswordPayload {
  username: string
  password: string
  newPassword: string
  confirmPassword: string
}

export interface APIResponse<T> {
  data: {
    message: string
    users?: T[]
    user?: T
  }
  status: string
  statusCode: number
}

// Get all users
export const fetchUsers = async (): Promise<User[]> => {
  try {
    const response = await apiServiceHandler.get<any>(GetUsersURL)

    if (response.statusCode === 200) {
      return response.data.users || []
    } else {
      throw new Error(response.data.message || "Failed to fetch users")
    }
  } catch (error) {
    console.error("Error fetching users:", error)
    throw error
  }
}

// Add new user
export const addUser = async (userData: UserFormData): Promise<User> => {
  try {
    const response = await apiServiceHandler.post<any>(AddUserURL, userData)
    if (response.statusCode === 200) {
      return response.data.user
    } else {
      throw new Error(response.data.message || "Failed to add user")
    }
  } catch (error) {
    console.error("Error adding user:", error)
    throw error
  }
}

// Update user
export const updateUser = async (userId: string, userData: Partial<UserFormData>): Promise<User> => {
  try {
    const UpdateUserURLString = `${UpdateUserURL}${userId}`;
    const response = await apiServiceHandler.put<any>(UpdateUserURLString, userData);
    if (response.statusCode === 200) {
      return response.data.user!
    } else {
      throw new Error(response.data.message || "Failed to update user")
    }
  } catch (error) {
    console.error("Error updating user:", error)
    throw error
  }
}

// Delete user
export const deleteUser = async (username: string): Promise<string> => {
  try {
    const DeleteUserData = `${DeleteUserURL}${username}`;
    const response = await apiServiceHandler.delete<any>(DeleteUserData);

    if (response.statusCode === 200) {
      return response.data.message
    } else {
      throw new Error(response.data.message || "Failed to delete user")
    }
  } catch (error) {
    console.error("Error deleting user:", error)
    throw error
  }
}

export const changePassword = async ( payload: ChangePasswordPayload ): Promise<string> => {
  try {
    const response = await apiServiceHandler.post<any>(ChangePasswordURL, payload)

    if (response.statusCode === 200) {
      return response.data.message || "Password changed successfully"
    } else {
      throw new Error(response.data.message || "Failed to change password")
    }
  } catch (error) {
    console.error("Error changing password:", error)
    throw error
  }
}
